import { render, staticRenderFns } from "./pi5-person-retention.vue?vue&type=template&id=8b2d8c7c"
import script from "./pi5-person-retention.vue?vue&type=script&lang=js"
export * from "./pi5-person-retention.vue?vue&type=script&lang=js"
import style0 from "./pi5-person-retention.vue?vue&type=style&index=0&id=8b2d8c7c&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports